if (!customElements.get('blaze-faq-accordion')) {
  class BlazeFaqAccordion extends HTMLElement {
    connectedCallback() {
      if (this.dataset.blazeFaqReady === 'true') return;

      this.dataset.blazeFaqReady = 'true';
      this.addEventListener('toggle', this.handleToggle, true);
    }

    handleToggle = (event) => {
      const currentItem = event.target;

      if (!(currentItem instanceof HTMLDetailsElement) || !currentItem.open) return;

      this.querySelectorAll('details[open]').forEach((item) => {
        if (item !== currentItem) item.open = false;
      });
    };
  }

  customElements.define('blaze-faq-accordion', BlazeFaqAccordion);
}
